<template>
  <div>
    <div id="game-message">
      <h1>Ruota il dispositivo</h1>
    </div>
    <div id="GameContent">
      <div id="game-container">
        <div class="grid">
          <CalledCard/>
          <div id="audio">
            <AudioSetting class="settingButton"></AudioSetting>
          </div>
          <div v-for="(player, index) in players" :id="'player'+(index +1)" :key="'player' + (index+1)">
            <div>
              <Player :player="player" :pos="index" :took="player.took"/>
            </div>
            <div id="gameButton" v-if="index==0">
              <game-button v-if="players[0].previous_card" @clicked="showLastHand = true" >ULTIMA PRESA</game-button>
              <!-- <game-button v-if="players[0].is_locked" @clicked="unlock()">SBLOCCA</game-button> NOT NOW-->
              <game-button @clicked="showConfirmModal = true">ABBANDONA</game-button>
            </div>
          </div>
          <div v-if="players[1].played_card" id="card-player2" class="played-card">
            <Card class="card" :cardId="players[1].played_card"/>
          </div>
          <div v-if="players[2].played_card" id="card-player3" class="played-card">
            <Card class="card" :cardId="players[2].played_card"/>
          </div>
          <div v-if="players[3].played_card" id="card-player4" class="played-card">
            <Card class="card" :cardId="players[3].played_card"/>
          </div>
          <div v-if="players[4].played_card" id="card-player5" class="played-card">
            <Card class="card" :cardId="players[4].played_card"/>
          </div>
          <div id="table">
            <draggable id="drag" v-if="callSection == 'finished'" v-bind="{group:'cards'}" :disabled="!!playedCard" class="draggable">
              <Card class="card" v-if="!!playedCard" v-bind:key="playedCard" :cardId="playedCard"/>
            </draggable>
            <CallTable v-else />
          </div>
          <div id="hand">
            <Hand/>
          </div>
          <div id="chat">
            <Chat :messages="messages" :game="game"></Chat>
          </div>
        </div>
      </div>
        <MatchResults v-if="showModal" @close="showModal = false" />
        <Modal v-if="showConfirmModal"  @close="showConfirmModal = false">
          <template slot="body">
            <h4>Sei sicuro di voler abbandonare il gioco?</h4>
            <h4>Ci saranno delle conseguenze...</h4>
          </template>
          <template slot="footer">
            <div class="flex">
              <game-button @clicked="showConfirmModal = false">ANNULLA</game-button>
              <game-button @clicked="exit()" :disabled="clicked">ABBANDONA</game-button>
            </div>
          </template>
        </Modal>
        <Modal v-if="showModalExit" @close="back()">
          <template slot="body">
            <h4>Purtroppo un utente ha abbandonato la partita.</h4>
            <h4>Puoi però continuare a giocare su un altro tavolo.</h4>
          </template>
          <template slot="footer">
            <game-button @clicked="back()">OK</game-button>
          </template>
        </Modal>
        <Modal v-if="showModalCallTie" @close="restart()">
          <template slot="body">
            <h4>Hanno passato tutti, vengono ridistribuite le carte</h4>
          </template>
          <template slot="footer">
            <div class="flex">
              <game-button @clicked="restart()">OK</game-button>
            </div>
          </template>
        </Modal>
        <LastHand v-if="showLastHand" @close="showLastHand = false"></LastHand>
      </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import Hand from "@/components/Hand";
import CallTable from "@/components/CallTable";
import CalledCard from "@/components/CalledCard";
import Player from "@/components/Player";
import draggable from 'vuedraggable';
import Card from "@/components/Card";
import Vue from "vue";
import { notify } from "../event-bus";
import MatchResults from "@/components/MatchResults";
import LastHand from "@/components/LastHand";
import GameButton from "@/components/Button"
import router from "@/router";
import Modal from "@/components/Modal";
import Chat from "@/components/Chat";
import AudioSetting from "@/components/AudioSetting";

export default {
  name: "Game",
  components: {
    Hand,
    draggable,
    CallTable,
    Player,
    Card,
    MatchResults,
    GameButton,
    Modal,
    Chat,
    LastHand,
    CalledCard,
    AudioSetting
  },
  mounted() {
    window.Echo.channel("table-" + this.tableActive.id).stopListening(
      "GameStartEvent"
    );
    window.Echo.channel("game-" + this.game.id).listen("CardPlayedEvent", (e) => {
      this.$store.commit("game/cardPlayed", e);
      this.$store.commit("game/updateUserTurn", e.nextUser);
    });
    window.Echo.channel("game-" + this.game.id).listen("CallEndTieEvent", () => {
      this.showModalCallTie = true;
    });
    window.Echo.channel("game-" + this.game.id).listen("HandWinnerEvent", (e) => {
      setTimeout(() => {
        this.$store.commit("game/lastHand", e);
        this.$store.commit("game/updateUserTurn", e.handWinner);
        this.$store.commit("game/updateUserTook", e.handWinner);
        this.$store.commit("game/resetPlayedCard");
      }, 3000);
    });
    window.Echo.channel("game-" + this.game.id).listen("MatchFinishedEvent", (e) => {
      setTimeout(() => {
        this.$store.commit("results/matchFinished", e);
        this.showModal = true;
        const payload = {
          id: this.game.id
        }
        this.$store.dispatch("game/retrieveGameData", payload);
      }, 3000);
    });
    window.Echo.channel("game-" + this.game.id).listen("GameDeletedEvent", () => {
      this.showModalExit = true;
    });
    window.Echo.channel("game-" + this.game.id).listen("UnlockGameEvent", (e) => {
      this.$store.commit("game/unlock", e);
    });
    window.Echo.channel("game-" + this.game.id).listen("BotReplaceEvent", (e) => {
      this.$store.commit("tables/changeBotInUser", e);
    });
    this.$store.dispatch("user/check").then((result) => {
      if (!result) {
        this.$store.commit("call/resetCall");
        this.$store.commit("game/exit");
        this.$store.commit("chat/resetChat");
        this.$store.commit("results/resetResults");
      }
    });
  },
  beforeDestroy() {
    window.Echo.channel("game-" + this.game.id)
      .stopListening('CardPlayedEvent')
      .stopListening('HandWinnerEvent')
      .stopListening('MatchFinishedEvent')
      .stopListening('GameDeletedEvent')
      .stopListening('UnlockGameEvent')
      .stopListening('BotReplaceEvent');
  },
  computed: {
    ...mapState({
      game: state => {
        return state.game.game;
      },
      playedCard: (state) => {
        return state.game.players[0].played_card;
      }
    }),
    ...mapGetters({ 
      user: "user/user" , 
      players: "game/players",
      callSection: "call/callSection",
      tableActive: "tables/tableActive",
      messages: "chat/messages"
    })
  },
  watch: {
    'playedCard': function() {
      if (this.playedCard) {
        Vue.http
        .post(
          `${process.env.VUE_APP_BACKEND_APP}/api/games/${this.$store.state.game.game.id}/users/${this.$store.state.user.user.id}/play`,
          {card: this.playedCard}
        ).catch((error) => {
          notify(error, "ERROR");
        });
      }
    }
  }, 
  data() {
    return {
      itsCallTime: true,
      dealButton: true,
      takeButton: false,
      showModal: false,
      showModalExit: false,
      showConfirmModal: false,
      showModalCallTie: false,
      showLastHand: false,
      clicked: false
    };
  },
  methods: {
    exit() {
      this.clicked = true;
              
      const payload = {
        userId: this.players[0].id
      }
      this.$store.dispatch("tables/leaveTable", payload)
        .then((result) => {
          this.$store.commit("call/resetCall");
          this.$store.commit("game/exit");
          this.$store.commit("chat/resetChat");
          this.$store.commit("results/resetResults");
          if (!result) {
              const userData = {
                userId: this.user.id,
              };
              this.$store.dispatch("user/deleteUser", userData).then(() => {
                router.push("/");
              });
            } else {
              const query= {
                q: "",
                orderBy: "id",
                order: "ASC",
                page: 1,
                limit: 8,
              }
              this.$store.dispatch("tables/fetchTables", query).then(() => {
                router.push("/tables")
              });
            }
        });
      
    },
    restart() {
      this.$store.commit("game/resetCards");
      this.$store.commit("call/resetCall");
      const payload = {
        id: this.game.id
      }
      this.$store.dispatch("game/retrieveGameData", payload);
      this.showModalCallTie = false;
    },
    unlock() {
      const payload = {
        userId: this.players[0].id,
        gameId: this.game.id
      };
      this.$store.dispatch("game/unlockGame", payload);
    },
    back() {
      this.showModalExit = false;
      this.exit();
    }
  }
};
</script>
<style scoped>
#GameContent {
  background-image: url('~@/assets/backg.jpg');
  display: flex;
  padding: 1em;
}
#game-message {
  display: none;
}
#table {
  min-width: 90px !important;
  justify-content: center;
}

.grid {
  margin-bottom: 12em;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-areas: 
    'calledCard           player4     player4   table table player3       player3        .'
    'calledCard             .      card-player4 table table card-player3     .           .'
    'player5 card-player5 card-player4 table table card-player3 card-player2 player2'
    'player5 card-player5       .      table table      .       card-player2 player2'
    'hand hand hand hand hand hand hand hand'
    '. player1 player1 . chat chat chat audio';
}
#table {
  grid-area: table;
  display: flex;
  align-items: flex-end;
  min-width: 180px;
  min-height: 300px;
}
@media all and (min-width: 1440px)   {
  .grid {
    grid-template-columns: 1.5fr repeat(6, 1fr) 2fr 2fr;
    grid-template-rows: 100px 180px 180px 180px 125px;
    grid-template-areas: 
      'calledCard  player4      player4      table table player3      player3      audio       chat'
      'calledCard  .            card-player4 table table card-player3 .            .       chat'
      'player5     card-player5 card-player4 table table card-player3 card-player2 player2 chat'
      'player5     card-player5 .            table table .            card-player2 player2 chat'
      'hand        hand         hand         hand  hand  hand         hand         hand    player1';
  }
}
@media all and (min-width: 960px) and (max-width: 1440px) {
  .grid {
    grid-template-columns: 1.5fr repeat(6, 1fr) 2fr;
    grid-template-rows: 100px 180px 180px 180px 250px 400px;
  }
}
@media all and (max-width: 960px) {
  .grid {
    grid-template-rows: 100px 180px 180px 180px 250px 350px;
  }
}

@media all and (max-width: 960px) {
  .grid {
    grid-template-rows: 70px 160px 160px 160px 250px 400px;
    grid-template-areas: 
      'calledCard           player4     player4   table table player3       player3        .'
      'calledCard              .      card-player4 table table card-player3     .           .'
      'player5 card-player5 card-player4 table table card-player3 card-player2 player2'
      'player5 card-player5       .      table table      .       card-player2 player2'
      'hand hand hand hand hand hand hand hand'
      'player1 player1 . chat chat chat chat audio';
  }
  #took {
    width: 80px;
    height: 150px;
  }
  #card-player5 {
    display: flex;
    align-items: center;
  }
  #card-player2 {
    display: flex;
    align-items: center;
  }
  #player1 {
    flex-direction: column;
    padding: 5em;
  }
}
@media all and (max-height: 860px) {
  .grid {
    grid-template-rows: 70px 160px 160px 160px 250px 400px;
  }
}
@media all and (max-height: 750px) {
  .grid {
    grid-template-rows: 90px 120px 120px 120px 250px 125px;
  }
}
@media all and (max-height: 620px) {
  .grid {
    grid-template-rows: 80px 100px 100px 100px 250px 125px;
  }
}
@media all and (max-height: 500px) {
  .grid {
      grid-template-rows: 65px 50px 60px 78px 250px 125px;
  }
  #table {
    min-height: unset;
  }
}

#chat {
  grid-area: chat;
  margin-top: auto;
}
#hand {
  grid-area: hand;
}
#called-card {
  grid-area: calledCard;
  max-width: 144px;
  display: flex;
  justify-self: center;
  width: 100%;
}
#audio {
  grid-area: audio;
  display: flex;
  align-items: center;
  justify-content: center;
}
.settingButton {
  background-color: lightseagreen;
  border: 2px solid black;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
#player1 {
  grid-area: player1;
  display: flex;
  align-items:center;
  justify-content: center;
}
#player2 {
  grid-area: player2;
}
#player3 {
  grid-area: player3;
}
#player4 {
  grid-area: player4;
  display: flex;
  justify-content: right;
  margin-left: 1em;
}
#player5 {
  grid-area: player5;
}
#card-player2 {
  grid-area: card-player2;
  transform: rotate(275deg);
}
#card-player3 {
  grid-area: card-player3;
  transform: rotate(20deg);
  display: flex;
  align-self: center;
}
#card-player4 {
  grid-area: card-player4;
  transform: rotate(-15deg);
  display: flex;
  align-self: center;
}
#card-player5 {
  grid-area: card-player5;
  transform: rotate(95deg);
}
#drag {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

#dealButton {
  background-color: rgb(0, 0, 0);
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
}
#dealButton:hover {
  background-color: rgb(74, 74, 74);
  color: white;
}
#chat {
  display: flex;
  align-items: flex-end;
  padding-bottom: 3em;
}
@media only screen and (max-width : 1000px){
  #audio {
    justify-content: flex-end;
  }
}
@media only screen and (max-width : 380px){
  #GameContent {
    display: none;
  }
  #game-message {
    display: block;
    color: black;
    width: 100%;
    position: absolute;
    margin-top: 50%;
  }
}

</style>
